import "./StatsGrid.css";

const StatsGrid = ({ stats }) => {
  if (!stats) return null;

  return (
    <div className="stats-grid">
      <div className="card">
        <span>Net Profit</span>
        <h2>{stats.netProfitLoss}</h2>
      </div>

      <div className="card">
        <span>Gross Profit</span>
        <h3>{stats.grossNetProfitLoss}</h3>
      </div>

      <div className="card">
        <span>Commission</span>
        <h3>{stats.totalCommission}</h3>
      </div>

      <div className="card">
        <span>Transactions</span>
        <h3>{stats.totalTransactions}</h3>
      </div>
    </div>
  );
};

export default StatsGrid;